import { PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { message, Input, Select, Tooltip, Alert } from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputItem,
  InputNumberItem,
  SelectItem,
  TextAreaItem,
  DatePickerItem,
  ButtonItem,
  ErrorItem,
  cuentaMask,
} from "../../../../Components/Items";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";

const { Option } = Select;

class EditarCredito extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoCuentaContable: null,
    objetoMonedas: null,
    todasMonedas: null,
    objetoProyectos: null,
    monedaEsMXN: true,
    utilizado: false,
    contablemente: true,
    abonoProveedor: false,
    modalAgregarCuentaContable: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoCuentaContable: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(
                  value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                ) +
                  " - " +
                  value.descripcion}
              </Option>
            )),
          });
        }
      });
    await axios
      .post("monedas/selectMonedas", null, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasMonedas: res.data,
            objetoMonedas: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre + " - " + value.abreviacion}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "creditos/datosCredito",
        { empresaId: this.props.empresaId, creditoId: this.props.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontró información del crédito");
        } else {
          //contablemente y abonoProveedor se deciden en el alta y no se pueden
          //editar, por eso salen del form y solo viven en el state para los avisos
          const { contablemente, abonoProveedor, ...datos } = res.data;
          const moneda = this.state.todasMonedas?.find(
            (m) => m._id === datos.monedaId
          );
          const esMXN = moneda?.abreviacion === "MXN";
          this.formRef.current.setFieldsValue({
            ...datos,
            fechaInicio: datos.fechaInicio ? moment(datos.fechaInicio) : null,
            fechaVencimiento: datos.fechaVencimiento
              ? moment(datos.fechaVencimiento)
              : null,
          });
          this.setState({
            monedaEsMXN: esMXN,
            utilizado: !!datos.utilizado,
            contablemente: contablemente !== false,
            abonoProveedor: abonoProveedor === true,
          });
        }
      });
    this.setState({ loading: false });
  }

  onChangeMoneda = (id) => {
    const moneda = this.state.todasMonedas?.find((m) => m._id === id);
    const esMXN = moneda?.abreviacion === "MXN";
    this.setState({ monedaEsMXN: esMXN });
    if (esMXN) {
      this.formRef.current.setFieldsValue({ tipoCambio: 1 });
    } else {
      this.formRef.current.setFieldsValue({ tipoCambio: undefined });
    }
  };

  cerrarEditarCredito() {
    this.setState({
      monedaEsMXN: true,
      utilizado: false,
      contablemente: true,
      abonoProveedor: false,
    });
    this.props.cerrarEditarCredito();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "creditos/editarCredito",
        {
          ...values,
          //En modalidad de abono el credito no tiene cuenta de cargo: mandarla
          //haria que el backend la tome como un cambio restringido
          cuentaContableCargoId: this.state.abonoProveedor
            ? undefined
            : values.cuentaContableCargoId,
          empresaId: this.props.empresaId,
          creditoId: this.props.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se editó un crédito");
          this.formRef.current.resetFields();
          this.cerrarEditarCredito();
        } else {
          message.error(res.data.message || "Sucedió un error y no se editó");
        }
      });
  }

  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }

  render() {
    //Un credito que abonó al proveedor no puede rehacer su poliza: eso implicaria
    //rehacer el abono, que puede estar aplicado a facturas. El backend lo trata
    //igual que a uno ya utilizado, asi que el form bloquea los mismos campos
    const soloCamposLibres = this.state.utilizado || this.state.abonoProveedor;

    return (
      <>
        <ModalItem
          title="Editar Crédito"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarEditarCredito.bind(this)}
        >
          {!this.state.contablemente && (
            <Alert
              type="info"
              showIcon
              message="Este crédito se dio de alta sin contabilidad: no tiene pólizas y editarlo no generará ninguna."
              style={{ marginBottom: 12 }}
            />
          )}
          {this.state.abonoProveedor && (
            <Alert
              type="info"
              showIcon
              message="Este crédito generó un abono al proveedor."
              description="Solo se pueden editar nombre, descripción, fecha de vencimiento y plazo: cambiar el monto, el proveedor o la moneda obligaría a rehacer el abono, que puede estar aplicado a facturas."
              style={{ marginBottom: 12 }}
            />
          )}
          <Form
            ref={this.formRef}
            name="editarCredito"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Editar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <FormItem name="nombre" label="Nombre" required margin pattern>
              <InputItem placeholder="Nombre" />
            </FormItem>
            <FormItem name="descripcion" label="Descripción" margin pattern>
              <TextAreaItem placeholder="Descripción" />
            </FormItem>
            <FormItem label="Proveedor" name="proveedorId" required margin>
              <SelectProveedoresItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                placeholder="Proveedor"
                disabled={soloCamposLibres}
              />
            </FormItem>
            <FormItem label="Proyecto" name="proyectoId" required margin>
              <SelectItem
                placeholder="Proyecto"
                disabled={soloCamposLibres}
              >
                {this.state.objetoProyectos}
              </SelectItem>
            </FormItem>
            <FormItem
              name="totalCredito"
              label="Total del Crédito"
              required
              number
              margin
            >
              <InputNumberItem
                dinero
                placeholder="Total del Crédito"
                disabled={soloCamposLibres}
              />
            </FormItem>
            <FormItem name="totalPagado" label="Total Pagado" numberCero margin>
              <InputNumberItem disabled dinero placeholder="Total Pagado" />
            </FormItem>
            <FormItem label="Moneda" name="monedaId" required margin>
              <SelectItem
                placeholder="Moneda"
                onChange={this.onChangeMoneda}
                disabled={soloCamposLibres}
              >
                {this.state.objetoMonedas}
              </SelectItem>
            </FormItem>
            {!this.state.monedaEsMXN && (
              <FormItem
                name="tipoCambio"
                label="Tipo de Cambio"
                required
                number
                margin
              >
                <InputNumberItem
                  placeholder="Tipo de Cambio"
                  disabled={soloCamposLibres}
                />
              </FormItem>
            )}
            <FormItem
              label={
                <span>
                  Cuenta Contable Crédito&nbsp;
                  <Tooltip title="De donde viene el dinero prestado. Ej: 'el banco me prestó $100,000'. Es la cuenta del banco o proveedor que te dio el crédito. En la póliza inicial aparece como abono (aumenta lo que debes).">
                    <QuestionCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                  </Tooltip>
                </span>
              }
              margin
            >
              <Input.Group compact>
                <FormItem name="cuentaContableCreditoId" required noStyle>
                  <SelectItem
                    placeholder="Cuenta Acreedor"
                    width="80%"
                    disabled
                  >
                    {this.state.objetoCuentaContable}
                  </SelectItem>
                </FormItem>
                <ButtonItem
                  disabled
                  icon={<PlusOutlined />}
                  style={{ width: "20%" }}
                  onClick={this.abrirAgregarCuentaContable.bind(this)}
                />
              </Input.Group>
            </FormItem>
            {/* En modalidad de abono no hay cuenta de cargo, y el FormItem de
                adentro es required: dejarlo montado bloquearia el envio */}
            {this.state.abonoProveedor ? (
              <FormItem label="Destino del crédito" margin>
                <InputItem disabled value="Abono al proveedor" />
              </FormItem>
            ) : (
              <FormItem
                label={
                  <span>
                    Cuenta Contable Cargo&nbsp;
                    <Tooltip title="Ahí es donde vas a recibir el dinero en la póliza inicial. Ej: 'esos $100,000 cayeron a mi cuenta de cheques / los usé para comprar maquinaria'. Aparece como cargo (entra el recurso).">
                      <QuestionCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                    </Tooltip>
                  </span>
                }
                margin
              >
                <Input.Group compact>
                  <FormItem name="cuentaContableCargoId" required noStyle>
                    <SelectItem
                      placeholder="Cuenta Cargo (Banco)"
                      width="80%"
                      disabled
                    >
                      {this.state.objetoCuentaContable}
                    </SelectItem>
                  </FormItem>
                  <ButtonItem
                    disabled
                    icon={<PlusOutlined />}
                    style={{ width: "20%" }}
                    onClick={this.abrirAgregarCuentaContable.bind(this)}
                  />
                </Input.Group>
              </FormItem>
            )}
            <FormItem
              name="fechaInicio"
              label="Fecha de Inicio"
              margin
            >
              <DatePickerItem
                placeholder="Fecha de Inicio"
                allowClear={false}
              />
            </FormItem>
            <FormItem
              name="fechaVencimiento"
              label="Fecha de Vencimiento"
              margin
            >
              <DatePickerItem
                placeholder="Fecha de Vencimiento"
                allowClear={false}
              />
            </FormItem>
            <FormItem name="plazo" label="Plazo (meses)" number margin>
              <InputNumberItem placeholder="Plazo en meses" />
            </FormItem>
          </Form>
        </ModalItem>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
            this
          )}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(EditarCredito);
